import React, { Component } from 'react'

import startCase from 'lodash/startCase'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { Tooltip } from 'react-tippy'

import searches from '../../../../../../utils/routing/searches'

class RankingBars extends Component {
  static propTypes = {
    name: PropTypes.string,
    popularity: PropTypes.number,
    relevance: PropTypes.number,
    salary: PropTypes.number,
    showSkillInfo: PropTypes.func,
    isMobile: PropTypes.bool.isRequired,
  }

  constructor(props) {
    super(props)

    this.state = {}
  }

  render() {
    const {
      name,
      popularity,
      relevance,
      salary,
      type,
      isMobile,
      showSkillInfo,
      skillDescription,
    } = this.props

    const skillDescriptionTooltipContent =
      skillDescription === null ? (
        <div>
          <div>Loading Description...</div>
        </div>
      ) : (
        <div>
          <h3
            style={
              name && name.toString().length < 4
                ? { textTransform: 'uppercase' }
                : { textTransform: 'capitalize' }
            }
          >
            <a
              href={`https://www.youtube.com/results?search_query=${name}+tutorial`}
              target="blank"
              style={{ fontWeight: 'bold' }}
            >
              <i className="fab fa-youtube" style={{ color: '#ff0000', marginRight: 8 }} />

              {name}
            </a>
          </h3>
          <div
            style={{
              fontSize: 12,
              maxHeight: 300,
              overflowY: 'auto',
              textAlign: 'left',
            }}
          >
            {skillDescription}
          </div>
        </div>
      )

    return (
      <div
        className="row ranking-row"
        style={{
          textTransform: name && name.toString().length < 4 ? 'uppercase' : 'capitalize',
          width: isMobile ? '100%' : 'auto',
          marginBottom: isMobile ? '10px' : '0',
        }}
      >
        <div
          className={isMobile ? 'col-md-6 text-center' : 'col-md-4'}
          style={isMobile ? { height: '20px' } : null}
        >
          {type === 'career' ? (
            <div
              style={{
                whiteSpace: 'nowrap',
                maxWidth: '100%',
                textOverflow: 'ellipsis',
                overflow: 'hidden',
              }}
            >
              <a href={`https://www.youtube.com/results?search_query=${name}+job`} target="blank">
                <i className="fab fa-youtube" style={{ color: '#ff0000', marginRight: 8 }} />
              </a>
              <Link
                to={searches.buildUrlForSavedResumeSearch({
                  searchParams: {
                    searchType: 'career',
                    search_query: name,
                  },
                })}
              >
                <Tooltip
                  arrow
                  delay={500}
                  title={'Search360° for "' + startCase(name) + '"'}
                  trigger="mouseenter"
                  position="top"
                >
                  <i className="fal fa-search" /> {name}
                </Tooltip>
              </Link>
            </div>
          ) : (
            <Tooltip
              arrow
              html={skillDescriptionTooltipContent}
              trigger="mouseenter"
              position="right"
              onShow={() => showSkillInfo(name)}
              theme="light"
              interactive={true}
              hideOnClick={true}
            >
              <a
                href={`https://www.youtube.com/results?search_query=${name}+tutorial`}
                target="blank"
              >
                <i className="fab fa-youtube" style={{ color: '#ff0000', marginRight: 8 }} />
                {name}
              </a>
            </Tooltip>
          )}
        </div>
        <div className={isMobile ? 'col col-6' : 'col'}>
          {isMobile && <i className="fal fa-fire mr-1" style={{ color: '#FF9551' }} />}
          <div className="bar-wrapper" style={isMobile ? { width: '85%', float: 'right' } : null}>
            <div
              className="scale-bars"
              style={{
                width: `${popularity}%`,
                background: '#FF9551',
              }}
            />
          </div>
        </div>
        {!isMobile && (
          <div className="col">
            <div className="bar-wrapper">
              <div
                className="scale-bars"
                style={{
                  width: `${relevance}%`,
                  background: '#99c4ee',
                }}
              />
            </div>
          </div>
        )}
        <div className={isMobile ? 'col col-6' : 'col'}>
          {isMobile && <i className="fa fa-dollar-sign mr-1" style={{ color: '#68CEB7' }} />}
          <div className="bar-wrapper" style={isMobile ? { width: '85%', float: 'right' } : null}>
            <div
              className="scale-bars"
              style={{
                width: `${salary}%`,
                background: '#68CEB7',
              }}
            />
          </div>
        </div>
      </div>
    )
  }
}

export default RankingBars



// WEBPACK FOOTER //
// ./src/routes/authenticated/Search/routes/components/components/RankingBars.js